import React, { useEffect, useState } from "react";
import Button from "../Button/Button";
import classes from "./Header.module.css";
import burgerImg from "../../img/burger.PNG";
import homeImg from "../../img/home.PNG";
import productsImg from "../../img/products.PNG";
import configureImg from "../../img/configure.PNG";
import profileImg from "../../img/profile.PNG";
import {BrowserRouter as Router, Routes, Route, NavLink} from 'react-router-dom'
import MainPage from '../Pages/MainPage/MainPage';
import Configure from '../Pages/Configure/Configure';
import Products from "../Pages/Products/Products";
import Profile from "../Pages/Profile/Profile";
import ProductCard from "../Pages/ProductCard/ProductCard";

const Header = (props) => {

  const [gradient, setGradient] = useState("");
  const [rightSlide, setRightSlide] = useState("");
  const [rightSlideClose, setRightSlideClose] = useState("");
  const [hoverMobileHeaderMain, setHoverMobileHeaderMain] = useState(`${classes.thisPage}`);
  const [hoverMobileHeaderProd, setHoverMobileHeaderProd] = useState("");
  const [hoverMobileHeaderConf, setHoverMobileHeaderConf] = useState("");
  const [hoverMobileHeaderProfile, setHoverMobileHeaderProfile] = useState("");
  const [scrollMobileHeaderUse, setScrollMobileHeaderUse] = useState("");
  const [scrollMobileHeaderI, setScrollMobileHeaderI] = useState(0);
  const [sliderMobileHeader, setSliderMobileHeader] = useState("");
  const [sliderMobileHeaderLink, setSliderMobileHeaderLink] = useState("");
  const [sliderBgCloserMobileHeaderLink, setSliderBgCloserMobileHeaderLink] = useState("none");

  const classesMobileHeaderLink = classes.LinkBlock + " " + sliderMobileHeaderLink

  // animation: sliderMobileHeader 1s 1 ease;

  window.addEventListener("scroll", () => {
    if (window.scrollY >= 100) {
      setGradient(
        "linear-gradient(0deg, rgba(255,255,255,0.01) 0%, rgba(0,0,0,0.64) 100%)"
      );
    } else {
      setGradient("");
    }
  });
  
  

  // скролл мобильный header
  const scrollMobileHeader = () => {
    if (scrollMobileHeaderI % 2 === 0) {
      setSliderBgCloserMobileHeaderLink("block")
      setScrollMobileHeaderUse("325px")
      setTimeout(() => {
        setSliderMobileHeaderLink(classes.activeHeaderBar)
      }, 150)
      setSliderMobileHeader("sliderMobileHeader 0.2s 1 ease")
      setTimeout(() => {
        setSliderMobileHeader("")
      }, 10)
    } else {
      window.innerHeight <= 750 ? setScrollMobileHeaderUse("88px") : setScrollMobileHeaderUse("108px")
      setSliderMobileHeaderLink("")
      setSliderMobileHeader("sliderMobileHeader 0.2s 1 ease")
      setTimeout(() => {
        setSliderBgCloserMobileHeaderLink("none")
      }, 150)
      setTimeout(() => {
        setSliderMobileHeader("")
      }, 10)
    }
    setScrollMobileHeaderI(scrollMobileHeaderI + 1)
  }


  // анимация для адаптированной версии
  const burgerOnClick = () => {
    setRightSlide(" translateX(0px) ")
    setRightSlideClose(" translateX(0px) ")
  }
  const closeOnMouseOver = () => {
    setRightSlide(" translateX(100px) ")
    setRightSlideClose(" translateX(0px) ")
  }
  const closeOnClick = () => {
    setRightSlide(" translateX(500px) ")
    setRightSlideClose(" translateX(1400px) ")
  }

  // для мобильной версии
  // over
  const hoverMobileHeaderMainFunc = () => {
    setHoverMobileHeaderMain(`${classes.active}`)
  }
  const hoverMobileHeaderProdFunc = () => {
    setHoverMobileHeaderProd(`${classes.active}`)
  }
  const hoverMobileHeaderConfFunc = () => {
    setHoverMobileHeaderConf(`${classes.active}`)
  }
  const hoverMobileHeaderProfileFunc = () => {
    setHoverMobileHeaderProfile(`${classes.active}`)
  }
  // out
  const hoverMobileHeaderMainFuncOut = () => {
    setHoverMobileHeaderMain(`${classes.active}`)
  }
  const hoverMobileHeaderProdFuncOut = () => {
    setHoverMobileHeaderProd("")
  }
  const hoverMobileHeaderConfFuncOut = () => {
    setHoverMobileHeaderConf("")
  }
  const hoverMobileHeaderProfileFuncOut = () => {
    setHoverMobileHeaderProfile("")
  }

  return (
    <div>
      <Router>
      {/* Основной хедер */}
      <header id={classes.mainHeader} style={{ background: gradient }}>
        <div>
          <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/"><p>ETS</p></NavLink>
        </div>
        <div className={classes.contentHeader}>
          <div className={classes.contentTextHeader}>
            <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/" className={({isActive}) => isActive ? classes.activeLink : ''}><p>Главная</p></NavLink>
            <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/Products" className={({isActive}) => isActive ? classes.activeLink : window.location.pathname.slice(1) === "ProductCard" ? classes.activeLink : ""}><p>Продукция</p></NavLink>
            <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/Configure" className={({isActive}) => isActive ? classes.activeLink : ''}><p>Конфигурация</p></NavLink>
          </div>
          <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/Profile"><Button title="Авторизация" /></NavLink>
        </div>
      </header>



      

      {/* хедер для маньшего экрана */}
      <header id={classes.secondHeader} style={{ background: gradient }}>

        <div className={classes.contentSecondHeader}>
          <div>
            <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/"><p>ETS</p></NavLink>
          </div>
          <img onClick={burgerOnClick} className={classes.burger} src={burgerImg} alt="Навигация"/>
        </div>

        <div className={classes.closeRightMenu} style={{ transform: rightSlideClose }} onMouseOver={closeOnMouseOver} onClick={closeOnClick}></div>
        <div className={classes.rightMenu} style={{ transform: rightSlide }} onMouseOver={burgerOnClick}>
          <div className={classes.rightMenuContent}>
            <h1>ЭнергоТестСервис</h1>
            <div className={classes.links}>
              <div><NavLink onClick={()=>{window.scrollTo(0,0)}} to="/" className={({isActive}) => isActive ? classes.activeLink : ''}><img src={homeImg} alt="Главная" /><h2>Главная</h2></NavLink></div>
              <div><NavLink onClick={()=>{window.scrollTo(0,0)}} to="/Products" className={({isActive}) => isActive ? classes.activeLink : window.location.pathname.slice(1) === "ProductCard" ? classes.activeLink : ""}><img src={productsImg} alt="Продукция" /><h2>Продукция</h2></NavLink></div>
              <div><NavLink onClick={()=>{window.scrollTo(0,0)}} to="/Configure" className={({isActive}) => isActive ? classes.activeLink : ''}><img src={configureImg} alt="Конфигурация" /><h2>Конфигурация</h2></NavLink></div>
              <div><NavLink onClick={()=>{window.scrollTo(0,0)}} to="/Profile" className={({isActive}) => isActive ? classes.activeLink : ''}><img src={profileImg} alt="Профиль" /><h2>Профиль</h2></NavLink></div>
            </div>
          </div>
        </div>

      </header>





      {/* хедер для мобилок */}
      <div onTouchStart={scrollMobileHeader} style={{display: sliderBgCloserMobileHeaderLink}} className={classes.bgCloser}></div>
      <header id={classes.mobileHeader}>
        <div className={classes.contentMobileHeader} style={{height: scrollMobileHeaderUse}}>
          <div className={classes.slidePanel}>
            {/* <div className={classes.SliderDiv} onTouchStart={scrollMobileHeader}><div style={{animation: sliderMobileHeader}} className={classes.Slider}></div></div> */}
            <div className={classesMobileHeaderLink}>
              <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/" className={({isActive}) => isActive ? classes.activeLink : ''}><div className={hoverMobileHeaderMain} onMouseOver={hoverMobileHeaderMainFunc} onMouseOut={hoverMobileHeaderMainFuncOut}><img src={homeImg} alt="Главная" /></div></NavLink>
              <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/Products" className={({isActive}) => isActive ? classes.activeLink : window.location.pathname.slice(1) === "ProductCard" ? classes.activeLink : ""}><div className={hoverMobileHeaderProd} onMouseOver={hoverMobileHeaderProdFunc} onMouseOut={hoverMobileHeaderProdFuncOut}><img src={productsImg} alt="Продукция" /></div></NavLink>
              <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/Configure" className={({isActive}) => isActive ? classes.activeLink : ''}><div className={hoverMobileHeaderConf} onMouseOver={hoverMobileHeaderConfFunc} onMouseOut={hoverMobileHeaderConfFuncOut}><img src={configureImg} alt="Конфигурация" /></div></NavLink>
              <NavLink onClick={()=>{window.scrollTo(0,0)}} to="/Profile" className={({isActive}) => isActive ? classes.activeLink : ''}><div className={hoverMobileHeaderProfile} onMouseOver={hoverMobileHeaderProfileFunc} onMouseOut={hoverMobileHeaderProfileFuncOut}><img src={profileImg} alt="Профиль" /></div></NavLink>
            </div>
          </div>
        </div>
      </header>
        <Routes>
          <Route exact path='/' Component={MainPage} />
          <Route path='/Configure' Component={Configure} />
          <Route path='/Products' Component={Products} />
          <Route path='/Profile' Component={Profile} />
          <Route path='/ProductCard' Component={ProductCard} />
        </Routes>
      </Router>
    </div>
  );
};

export default Header;
